import { conversionRateBus } from "@/event/conversionRateBus"
import { quantityBus } from "@/event/product/quantityBus"
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy"

export function selectedPriceProductHappy(price: string | number) {
    const priceNumber = typeof price === 'string' ? parseFloat(price) : price
    let convertedPrice = priceNumber * conversionRateBus.value * quantityBus.value

    if (selectOptionsListHappy.value) {
        Object.values(selectOptionsListHappy.value).forEach((option) => {
            const radioOption = option.selected_values.radio_option
            const checkboxOption = option.selected_values.checkbox_option

            if (radioOption.option_value_price) {
                convertedPrice = convertedPrice + (Number(radioOption.option_value_price) * conversionRateBus.value * quantityBus.value)
            }

            if (checkboxOption.option_value_paid.length !== 0) {
                Object.values(checkboxOption.option_value_paid).forEach((ov) => {
                    convertedPrice = convertedPrice + (Number(ov.option_value_price) * conversionRateBus.value * quantityBus.value)
                })
            }
        })
    }

    return convertedPrice.toFixed(2)
}